import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { SECTION_NAMES } from '@constants/sectionNames'
import { ButtonClean, HeadContent, Loading, useModalContext } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import { AppsSpotifySkeleton } from './AppsSpotifySkeleton'
import { AddMembersOnlyAudio } from './components/AddMembersOnlyAudio/AddMembersOnlyAudio'
import { AddPodcastButton } from './components/AddPodcastButton/AddPodcastButton'
import { Podcast } from './components/Podcast/Podcast'
import { PodcastsList } from './components/PodcastsList/PodcastsList'
import { usePodcastsQuery } from './hooks/usePodcastsQuery'
import { NewPodcastModal } from './modules/NewPodcastModal'

export const AppsSpotify = () => {
  const navigate = useNavigate()
  const modal = useModalContext()
  const { podcastsQuery } = usePodcastsQuery()

  if (!podcastsQuery.data) return <AppsSpotifySkeleton />

  const renderContent = () => {
    if (podcastsQuery.data.podcasts.length === 0)
      return <AddMembersOnlyAudio onClick={() => modal.open(NewPodcastModal)} />

    return (
      <Loading isLoading={podcastsQuery.isFetching}>
        <PodcastsList>
          {podcastsQuery.data?.podcasts.map((podcast) => (
            <Podcast
              key={podcast.id}
              status={podcast.status}
              artworkUrl={podcast.imageUrl}
              title={podcast.name}
              url={podcast.spotifyUrl}
              onClick={() => {
                navigate(
                  reverse(routing.apps.spotify.podcast.self, {
                    podcastId: podcast.id,
                  }),
                )
              }}
            />
          ))}
          <AddPodcastButton onClick={() => modal.open(NewPodcastModal)} />
        </PodcastsList>
      </Loading>
    )
  }

  return (
    <>
      <HeadContent title={SECTION_NAMES.appSpotify} />
      <PageLayout size="tiny">
        <Dashboard.Section
          name={SECTION_NAMES.appSpotify}
          topContent={<DashboardBackButton label={SECTION_NAMES.apps} to={routing.apps.self} />}
          bottomContent={
            <p style={{ lineHeight: '150%' }}>
              Allow members to listen to your audio posts on Spotify. Only spoken audio content is
              allowed. Music and musical content are not accepted by Spotify and will be taken down.{' '}
              <ButtonClean
                label="Learn more"
                withUnderline
                href="https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify"
                target="_blank"
              />
            </p>
          }
        >
          {/* <div style={{ marginBottom: 40 }}>
            <YouTubeVideoEntry
              title="How to sync Spotify with Fourthwall"
              description="Watch our quick guide to learn all about members-only episodes on Spotify"
              size={podcastsQuery.data.podcasts.length > 0 ? 'compact' : 'regular'}
              videoId="oCYOQ3Wpw1w"
            />
          </div> */}
          {renderContent()}
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
